import type {ReactNode} from "react";

interface PeriodicTableShellProps {
    loading: boolean;
    minWidth: number;
    header: ReactNode;
    body: ReactNode;
}

export function PeriodicTableShell({loading, minWidth, header, body}: PeriodicTableShellProps) {
    return (
        <div
            className="relative rounded-lg border border-gray-200 shadow-sm"
            role={loading ? "status" : undefined}
            aria-busy={loading || undefined}
        >
            {loading && <span className="sr-only">Rapport wordt geladen</span>}
            <div className="w-full overflow-x-auto rounded-lg">
                <table
                    className="w-full border-separate border-spacing-0 text-[13px]"
                    style={{minWidth: `${minWidth}px`}}
                >
                    {header}
                    <tbody>{body}</tbody>
                </table>
            </div>
        </div>
    );
}
